import {FeatureFlags} from "@/pb/api/devplan/types/config";
import {useBoundStore} from "@/hooks/queries/stores/use-bound-store";
import {featureFlagsKeys} from "@/hooks/queries/queryKeys";
import {useQuery} from "@tanstack/react-query";
import {useOptionalCompanyId} from "@/hooks/use-company-id";
import {isCompanyFeatureFlagEnabled, isFeatureFlagEnabled} from "@/hooks/queries/feature-flags-utils";

export function useFeatureFlags() {
  const {fetchFeatureFlags} = useBoundStore()
  const queryKey = featureFlagsKeys.flags
  const queryFn = async () => {
    await fetchFeatureFlags()
    return true
  }
  const {isPending: loading, error} = useQuery({queryKey, queryFn})
  const flags = useBoundStore(s => s.featureFlags)
  return {flags, loading, error}
}

export function useFeatureFlag(checker: (ff: FeatureFlags) => boolean): boolean {
  return useBoundStore(s => isFeatureFlagEnabled(s.featureFlags, checker))
}

export function useCompanyFeatureFlag(flag: (ff: FeatureFlags) => string[], companyIdOverride?: number): boolean {
  const optionalCompanyId = useOptionalCompanyId()
  const companyId = companyIdOverride ?? optionalCompanyId
  return useBoundStore(s => {
    const companyLimits = companyId === undefined ? undefined : s.ownCompanyLimits[companyId]?.limits
    const paidOrTrialOrgEligible = Boolean(companyLimits?.paid && !companyLimits.forcedReadonly)
    return isCompanyFeatureFlagEnabled(s.featureFlags, companyId, flag, paidOrTrialOrgEligible)
  })
}
